// Кадр видео для превью (poster) в виде data URL, либо "" при ошибке. Промис всегда
// разрешается один раз — со страховочным таймаутом.
export const getVideoPoster = (file: File): Promise<string> =>
    new Promise((resolve) => {
        const objectUrl = URL.createObjectURL(file);
        const video = document.createElement("video");
        video.muted = true;
        video.playsInline = true;
        video.preload = "metadata";
        video.crossOrigin = "anonymous";

        let settled = false;

        const finish = (poster: string) => {
            if (settled) return;
            settled = true;
            URL.revokeObjectURL(objectUrl);
            resolve(poster);
        };

        const timeoutId = window.setTimeout(() => finish(""), 5000);

        const capture = () => {
            try {
                const width = video.videoWidth;
                const height = video.videoHeight;
                if (!width || !height) return finish("");

                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext("2d");
                if (!context) return finish("");

                context.drawImage(video, 0, 0, width, height);
                window.clearTimeout(timeoutId);
                finish(canvas.toDataURL("image/jpeg", 0.7));
            } catch {
                finish("");
            }
        };

        video.onloadeddata = () => {
            // Небольшой отступ, чтобы не поймать чёрный первый кадр
            const seekTo = isFinite(video.duration) ? Math.min(0.1, video.duration / 2) : 0;
            if (seekTo > 0) video.currentTime = seekTo;
            else capture();
        };
        video.onseeked = capture;
        video.onerror = () => finish("");

        video.src = objectUrl;
    });
